import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function PrivacyPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the static HTML file
    window.location.href = '/privacy-policy.html';
  }, [navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '16px',
      color: '#666'
    }}>
      Loading Privacy Policy...
    </div>
  );
}

export default PrivacyPolicy;
